import { API_CONFIG } from '../utils/constants';
import { assignRole, generateSocialHandles } from '../utils/roleAssignment';

// Fetches profiles from Random User API 
export const fetchProfiles = async () => {
  try {
    const url = `${API_CONFIG.BASE_URL}?results=${API_CONFIG.RESULTS_COUNT}&nat=${API_CONFIG.NATIONALITIES}`;
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    
    const data = await response.json();
    return transformProfiles(data.results);
  } catch (error) {
    console.error('Error fetching profiles:', error);
    throw new Error('Failed to load profiles. Please try again later.');
  }
};

// Transforms raw API data into enriched profile objects
const transformProfiles = (apiResults) => {
  return apiResults.map((user, index) => {
    const { category, role, company } = assignRole(index);
    const socialHandles = generateSocialHandles(user.name.first, user.name.last);
    
    return {
      id: user.login.uuid,
      name: `${user.name.first} ${user.name.last}`,
      role,
      category,
      company,
      email: user.email,
      phone: user.phone,
      photo: user.picture.large,
      location: `${user.location.city}, ${user.location.country}`,
      ...socialHandles
    };
  });
};
